<template>
  <div>
    <vs-popup :title="$t('PriceRows')" :active.sync="showModal">
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-table :data="model" class="custom-tbl" v-if="model.basePrice">
            <template slot-scope="{ data }">
              <vs-tr>
                <vs-td style="width: 50%">
                  {{ $t("Status") }}
                </vs-td>
                <vs-td style="width: 50%">
                  <span v-if="data.priceBoundaryStatus == 'Unchanged'">
                    {{ $t("Unchanged") }}
                  </span>
                  <span v-if="data.priceBoundaryStatus == 'Floor'">
                    {{ $t("Floor") }}
                  </span>
                  <span v-if="data.priceBoundaryStatus == 'Ceiling'">
                    {{ $t("Ceiling") }}
                  </span>
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td>
                  {{ $t("BasePrice") }}
                </vs-td>
                <vs-td>
                  {{ Number(data.basePrice).toLocaleString() }} ریال
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td>{{ $t("DeductionAndIncreaseAmount") }}</vs-td>
                <vs-td>
                  {{ Number(data.deductionAndIncreaseAmount).toLocaleString() }}
                  ریال
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td>{{ $t("BaseSalePrice") }}</vs-td>
                <vs-td>
                  {{ Number(data.contractBasePrice).toLocaleString() }} ریال
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td>{{ $t("SumOfDiscountsAmount") }}</vs-td>
                <vs-td>
                  {{ Number(data.sumOfDiscountsAmount).toLocaleString() }} ریال
                </vs-td>
              </vs-tr>
              <!-- <vs-tr>
                <vs-td>{{ $t("ContractPrice") }}</vs-td>
                <vs-td>
                  {{ Number(data.contractPrice).toLocaleString() }} ریال
                </vs-td>
              </vs-tr> -->
              <vs-tr>
                <vs-td>{{ $t("ValueAddedTax") }}</vs-td>
                <vs-td>
                  {{ Number(data.totalTax).toLocaleString() }} ریال
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td>{{ $t("BaseConsumerPrice") }}</vs-td>
                <vs-td class="p-0">
                  <span
                    >{{ Number(data.baseConsumerPrice).toLocaleString() }}
                    ریال
                  </span>
                </vs-td>
              </vs-tr>
              <vs-tr
                v-if="$tabHasPermission('EnableAutomaticUpdatePrice')"
                :style="[
                  autoUpdateSwitch
                    ? { background: '#38CA38 !important' }
                    : { background: '#FE6161 !important' },
                ]"
              >
                <vs-td>به روزرسانی اتوماتیک قیمت</vs-td>
                <vs-td>
                  <div
                    class="flex items-center justify-center"
                    :class="[autoUpdateSwitch ? 'cursor-not-allowed ' : '']"
                  >
                    <vs-switch
                      :disabled="autoUpdateSwitch"
                      v-model="autoUpdateSwitch"
                      @click="changeStateAutomaticPrice"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-table :data="model" class="pt-4">
            <template slot-scope="{ data }" v-if="model.priceWithoutBoundary">
              <vs-tr class="h-24">
                <vs-td
                  class="w-1/2 text-white"
                  :style="{ background: '#836dd8' }"
                >
                  <div class="flex flex-col">
                    <span>{{ $t("PriceWithoutBoundary") }}:</span>
                    <span class="value">
                      {{ Number(data.priceWithoutBoundary).toLocaleString() }}
                      ریال
                    </span>
                  </div>
                </vs-td>
                <vs-td
                  class="w-1/2 text-white"
                  :style="{ background: '#19bd59' }"
                >
                  <div class="flex items-center justify-evenly">
                    <div>
                      {{ $t("ConsumerPrice") }}:
                      <div
                        v-if="!onShowEditPrice"
                        class="flex items-center justify-center"
                      >
                        <vs-input
                          class="text-dark w-2/3"
                          v-model="newPrice"
                          @input="acceptOnlyNumbersOnPrice($event)"
                          @keyup.enter="updatePrice"
                        />
                        <span class="mr-3">ریال</span>
                      </div>
                      <div
                        v-if="onShowEditPrice"
                        class="flex justify-center items-center"
                      >
                        <span class="value mx-2">
                          {{ data.price.toLocaleString() }}
                        </span>
                        <span>ریال</span>
                      </div>
                    </div>
                    <div v-has-permission="'UpdatePriceManually'">
                      <vs-button
                        v-if="onShowEditPrice"
                        radius
                        size="medium"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-edit"
                        @click.prevent="
                          onShowEditPrice = !onShowEditPrice;
                          newPrice = data.price.toLocaleString();
                        "
                        class="bg_purple"
                      ></vs-button>
                      <div v-if="!onShowEditPrice" class="flex mt-2">
                        <vs-button
                          class="submit-btn bg_l_blue mx-2"
                          @click.prevent="updatePrice"
                          >{{ $t("Submit") }}</vs-button
                        >
                        <vs-button
                          size="small"
                          class="float-right p-3"
                          @click.prevent="onShowEditPrice = !onShowEditPrice"
                          >{{ $t("Cancel") }}</vs-button
                        >
                      </div>
                    </div>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<style lang="scss">
.vs-con-table .vs-con-tbody {
  border-top: 0;
}
#price-tbl .vs-table--tbody-table .tr-values td:nth-child(2n) {
  background-color: #f3f3f3;
}
#price-tbl .vs-table--tbody-table .tr-values td:nth-child(2n + 1) {
  color: #666;
  font-weight: bold;
}
.vs-table--tbody-table .priceWithoutBoundary {
  color: #fff !important;
  font-weight: bold;
  background-color: #836dd8 !important;
  padding: 1rem !important;
  width: 50%;
}

.vs-table--tbody-table .consumerPrice {
  color: #fff !important;
  font-weight: bold;
  background-color: #19bd59 !important;
  padding: 1rem !important;
}

.priceWithoutBoundary,
.consumerPrice {
  border: none !important;
}
.priceWithoutBoundary .value,
.consumerPrice .value {
  display: block;
  margin-top: 0.25rem;
}
.vs-table--tbody-table .tr-values td {
  padding: 0.5rem;
}
</style>
<script>
import { mapActions } from "vuex";
export default {
  name: "saleManagement_Contract_Management_ProductPricesPopup",
  data() {
    return {
      onShowEditPrice: true,
      newModel: {},
      newModelForAutomatePrice: {},
      newPrice: this.model.price,
      autoUpdateSwitch: this.model.isAutomatedPriceUpdate,
    };
  },
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },
  watch: {
    showModal: {
      handler: function () {
        this.autoUpdateSwitch = this.model.isAutomatedPriceUpdate;
      },
    },
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.onShowEditPrice = true;
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      UpdatePriceMethod: "specificProduct/updatePrice",
      AutomatePrice: "specificProduct/AutomatePrice",
    }),
    cancelForPrice() {
      this.onShowEditPrice = false;
    },
    changeStateAutomaticPrice() {
      this.newModelForAutomatePrice = {
        contractId: this.model.contractId,
        specificProductId: this.model.productId,
      };
      this.AutomatePrice(this.newModelForAutomatePrice)
        .then(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            showConfirmButton: false,
            timer: 2000,
          });
          setTimeout(() => {
            this.$emit("update");
          }, 1500);
        })
        .catch((err) => {
          this.autoUpdateSwitch = !this.autoUpdateSwitch;
          this.$swal({
            position: "center-center",
            type: "error",
            text: "خطا",
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },
    updatePrice() {
      this.newModel = {
        contractId: this.model.contractId,
        specificProductId: this.model.productId,
        price: Number(this.newPrice.replace(/,/g, "")),
      };
      this.UpdatePriceMethod(this.newModel).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "قیمت با موفقیت به روزرسانی شد!",
          showConfirmButton: false,
          timer: 2000,
        });
        this.model.price = this.newModel.price;
        setTimeout(() => {
          this.autoUpdateSwitch = false;
          this.$emit("update");
        }, 1200);
        this.onShowEditPrice = !this.onShowEditPrice;
      });
    },
    acceptOnlyNumbersOnPrice(event) {
      let price = event.toLocaleString();
      this.newPrice = price;
    },
  },
};
</script>
